const init = () => {
    $("select:not(#exchangeInput):not(.custom-select)").each(function () {
        var $this = $(this),
            numberOfOptions = $(this).children("option").length;

        $this.addClass("s-hidden");

        $this.wrap('<div class="select"></div>');

        $this.after('<div class="styledSelect"></div>');

        var $styledSelect = $this.next("div.styledSelect");

        $styledSelect.text($this.children("option").eq(0).text());

        var $list = $("<ul />", {
            class: "options",
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            $("<li />", {
                text: $this.children("option").eq(i).text(),
                rel: $this.children("option").eq(i).val(),
            }).appendTo($list);
        }

        var $listItems = $list.children("li");
        var $firstItem = $listItems.eq(0);
        $firstItem.addClass("activeItem");
        if ($styledSelect.parents(".custom-select-container").hasClass("variation-select")) {
            $("body").trigger("variationSelect:change", { url:   $firstItem.attr("rel") });
        }

        $styledSelect.click(function (e) {
            e.stopPropagation();
            $("div.styledSelect.active").each(function () {
                $(this).removeClass("active").next("ul.options").hide();
            });
            $(this).next("ul.options").toggle();
        });

        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass("active");
            $listItems.removeClass("activeItem");
            $this.val($(this).attr("rel"));
            $(this).toggleClass("activeItem");
            $list.hide();
            if ($styledSelect.parents(".custom-select-container").hasClass("variation-select")) {
                $("body").trigger("variationSelect:change", { url: $(this).attr("rel") });
            }
        });

        $(document).click(function () {
            $styledSelect.removeClass("active");
            $list.hide();
        });
    });
    // Handle sort order menu selection
    const $list = $(".sorting-select .select ul.options");
    const $listItems = $list.children("li");
    $listItems.click(function (e) {
        e.stopPropagation();
        const url = $(this).attr("rel");

        $.spinner().start();
        $(this).trigger("search:sort", url);
        $.ajax({
            url: url,
            data: { selectedUrl: url },
            method: "GET",
            success: function (response) {
                $(".product-grid").empty().html(response);
                $(".pagination-link").removeClass("active");
                $(".pagination-link").first().addClass("active");
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    });
};

module.exports = {
    init,
    methods: {},
};
